/**
 * Implements a mobile sidebar section placeholder
 */
import Skeleton from 'react-loading-skeleton';

interface ISidebarPlaceholderProps {
  count: number;
  price?: boolean;
}

const SidebarPlaceholder = ({ count, price }: ISidebarPlaceholderProps) => {
  return (
    <>
      {price && (
        <div className='mobile_seo_page__converter'>
          <Skeleton width={120} height={18} />
          <div className='mobile_seo_page__converter__form'>
            <Skeleton height={36} count={2} />
          </div>
          <Skeleton height={16} />
        </div>
      )}

      <div className='mobile_seo_page__statistics'>
        <div className='mobile_seo_page__statistics__title'>
          <Skeleton width={205} height={24} />
        </div>
        <div className='mobile_seo_page__statistics__info'>
          <Skeleton height={30} count={count} />
        </div>
      </div>
    </>
  );
};

export default SidebarPlaceholder;
